
const Constants = {
   AddDeck: 'deck_addDeck',
   SetDeckList: 'deck_setDeckList',
   AddCardsToDeck: 'deck_addCardsToDeck',
   RemoveCardFromDeck: 'deck_removeCardFromDeck'
};

exports.Reducer = (state={},action) =>{
   switch(action.type){
      case Constants.AddDeck:{
         let decks = state.deckList.slice();
         decks.push(action.deck);
         return {...state, deckList: decks};
      }
      case Constants.SetDeckList:
         return {...state, deckList: action.deckList};
      case Constants.AddCardsToDeck:{
         let decks = state.deckList.slice();
         let deckMap = {};
         for(let deck of decks){
            deckMap[deck.idDeck] = deck;
         }
         for(let insertData of action.insertDataArray){
            deckMap[insertData.idDeck].cards[insertData.card.cardType + '_' + insertData.card.id] = insertData.card;
         }

         return {...state, deckList: decks};
      }
      case Constants.RemoveCardFromDeck: {
         let decks = state.deckList.slice();
         let processed = [];
         for(let deck of decks){
            if(deck.idDeck === action.idDeck){
               let cards = {...deck.cards};
               delete cards[action.cardType + '_' + action.idCard];
               processed.push({...deck, cards: cards});
            }
            else{
               processed.push(deck);
            }
         }
         return {...state, deckList: processed};
      }
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.addDeck = (deck) => {
   return{
      type: Constants.AddDeck,
      deck
   }
};

FunctionList.setDeckList = (deckList) => {
   return{
      type: Constants.SetDeckList,
      deckList
   }
};

/**
 * Adds an array of cards into the deck specified in each array entry
 * @param {object[]}insertDataArray - Each object in the array should have the form {card : <formatted card object>, idDeck: <id of an existing deck>}
 */
FunctionList.addCardsToDeck = (insertDataArray) => {
   return{
      type: Constants.AddCardsToDeck,
      insertDataArray
   }
};

FunctionList.removeCardFromDeck = (idCard, cardType, idDeck) => {
   return{
      type: Constants.RemoveCardFromDeck,
      idCard,
      cardType,
      idDeck,
   }
};

exports.FunctionList = FunctionList;
